import React from "react";
import { FaDiscord } from "react-icons/fa";
import "./infomarquee.css";

const InfoMarquee = () => (
    <div className="infomarquee-wrapper">
        <div className="infomarquee-marquee">
            <span className="infomarquee-icon-wrapper">
                <FaDiscord className="infomarquee-icon" />
            </span>
            <span className="infomarquee-text">
                <b>Join the C4GT community on Discord</b> to be the first to know when applications are live and stay updated on all things related to the program.
            </span>
        </div>
    </div>
);

export default InfoMarquee;